export default __webpack_public_path__ + "static/background-5-e411cf1b6514e15abae75c5e9b7d33e8.png";